import { put, call, all, takeEvery, select } from "redux-saga/effects";
import _ from "lodash";
import { VIEWER, ENDPOINT } from "../constants";
import LocalStorageHelper from "../utils/helper/localstorage_helper";
import { setPageTopLoader, setViewerImageData } from "../actions";
import { getDataFromKpiDash } from "../api";

const S3_BUCKET_BASE_URL = process.env.REACT_APP_S3_BUCKET_BASE_URL;

export const startDate = (state) => state.app.dateRange[0];
export const endDate = (state) => state.app.dateRange[1];
export const selectedMissionLabel = (state) => state.app.selectedMissionLabel;

const keywords = [
  "ぬまづの宝",
  "防災",
  "観光",
  "聖地巡礼",
  "ピクトレ",
  "当別町",
  "苫前町",
  "体験ミッション",
  "にいがた",
  "国際通り",
  "島めぐり",
  "那覇市"
];

export function* handleImageDataByFileName(actions) {
  try {
    yield put(setPageTopLoader(true));
    const missionSelectedName = yield select(selectedMissionLabel);
    const isSpecialMission =
      !!missionSelectedName &&
      keywords.some((keyword) => missionSelectedName.includes(keyword));

    const companyName = LocalStorageHelper.getCompany();
    const cleanFileName = actions.payload.includes(".jpg")
      ? actions.payload.replace(".jpg", "")
      : actions.payload.includes(".webp") ? actions.payload.replace(".webp", "") : actions.payload;

    let fileName = actions.payload.includes(".webp") ? `${cleanFileName}.webp` : `${cleanFileName}.jpg`;
    fileName = fileName.replace("本柱 支柱", "本柱＋支柱");
    const safeFileName = fileName.replace(/'/g, "''");

    const env = process.env.REACT_APP_ENV;
    let companyTableName = `power_asset_detail_of_tepco`;
    if (companyName === "ntt") {
      companyTableName = `power_asset_detail_of_ntt_me`;
    } else if (companyName === "ntt-ft") {
      companyTableName = env === "dev" ? `power_asset_detail_of_ntt_me` : `power_asset_detail_of_ntt_ft`;
    } else if (companyName === "hokuden") {
      companyTableName = `power_asset_detail_of_hepco`;
    }

    const joinTableAdjustment = companyTableName;

    //URLからseason不明を判明
    const sqlGetPpa = {
      query: `
        SELECT
          ppa.id AS ppa_id,
          ppa.power_asset_id,
          ppa.player_id,
          ppa.game_space_id,
          ppa.file_name,
          ppa.object_key
        FROM photo_of_power_asset ppa
        WHERE ppa.file_name = '${safeFileName}'
        ORDER BY ppa.id DESC
        LIMIT 1;
      `,
    };

    const [ppaTemp] = yield all([
      call(getDataFromKpiDash, sqlGetPpa, ENDPOINT.GET_DATA_API_REPLICA),
    ]);
    const ppaRow = JSON.parse(ppaTemp.body)?.[0];
    if (!ppaRow) {
      yield put(setViewerImageData([]));
      yield put(setPageTopLoader(false));
      return;
    }

    const ppaIdFromDb = ppaRow.ppa_id;

    const sqlHasRrpb = {
      query: `
        SELECT rrpb.review_request_id
        FROM review_request_photo_bind rrpb
        WHERE rrpb.photo_of_power_asset_id = '${ppaIdFromDb}'
        LIMIT 1;
      `,
    };

    const [rrpbTemp] = yield all([
      call(getDataFromKpiDash, sqlHasRrpb, ENDPOINT.GET_DATA_API_REPLICA),
    ]);
    const rrpbRow = JSON.parse(rrpbTemp.body)?.[0];
    const reviewRequestId = rrpbRow?.review_request_id; // 旧方式で使う

    // Query step1: Get review_request_id by a param file name
    // ---------- Query step1: review_request_id 取得 ----------
    // ★ 特殊ミッションの場合は padtep を SELECT / JOIN から除外
    const padtepSelectFragment = isSpecialMission ? "" : ", padtep.*";
    const padtepJoinFragment = isSpecialMission
      ? ""
      : `
        JOIN ${joinTableAdjustment} padtep
          ON pae.power_asset_id = padtep.power_asset_id
      `;

    let sqlQuery1 = {
      query: `
        SELECT
            ppa.*,
            gs.*,
            gt.*,
            pae.occurred_datetime AS occurred_datetime,
            CONVERT_TZ(pae.occurred_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
            ps.*${padtepSelectFragment},
            rrpb.review_request_id,
            pa.*
        FROM
            power_asset_event pae
        JOIN
            photo_of_power_asset ppa ON ppa.power_asset_id = pae.power_asset_id
            AND ppa.player_id = pae.player_id
            AND ppa.game_space_id = pae.game_space_id
        JOIN
            game_space gs ON gs.id = pae.game_space_id
        JOIN
            game_term gt ON gt.id = gs.game_term_id
        JOIN
            player_state ps ON pae.player_id = ps.player_id
        ${padtepJoinFragment}
        JOIN review_request_photo_bind rrpb ON rrpb.photo_of_power_asset_id = ppa.id
        JOIN
            power_asset pa ON pa.id = pae.power_asset_id
        WHERE
            pae.type = 'PHOTOGRAPH'
            AND ppa.file_name = '${safeFileName}'
        GROUP BY
            pae.power_asset_id, ps.player_id, occurred_datetime
        ORDER BY
            pae.occurred_datetime DESC
        LIMIT 1
      `,
    };

    if (reviewRequestId == undefined) {
      // new season / no rrpb case
      sqlQuery1.query = `
        SELECT
            ppa.*,
            gs.*,
            gt.*,
            pae.occurred_datetime AS occurred_datetime,
            CONVERT_TZ(pae.occurred_datetime, '+00:00', '+09:00') AS occurred_datetime_jst,
            ps.*${padtepSelectFragment},
            NULL AS review_request_id,
            pa.*
        FROM photo_of_power_asset ppa
        JOIN power_asset_event pae
          ON pae.power_asset_id = ppa.power_asset_id
        AND pae.player_id      = ppa.player_id
        AND pae.game_space_id  = ppa.game_space_id
        JOIN game_space gs ON gs.id = ppa.game_space_id
        JOIN game_term gt ON gt.id = gs.game_term_id
        JOIN player_state ps ON ps.player_id = ppa.player_id
        ${padtepJoinFragment}
        JOIN power_asset pa ON pa.id = ppa.power_asset_id
        WHERE
          pae.type = 'PHOTOGRAPH'
          AND ppa.file_name = '${safeFileName}'
        ORDER BY pae.occurred_datetime DESC
        LIMIT 1
      `;
    }

    const [imageReviewDataTemp] = yield all([
      call(getDataFromKpiDash, sqlQuery1, ENDPOINT.GET_DATA_API_REPLICA),
    ]);
    const imageReviewData = JSON.parse(imageReviewDataTemp.body) || [];
    if (!imageReviewData.length) {
      console.log("No imageReviewData for fileName:", fileName);
      yield put(setViewerImageData([]));
      yield put(setPageTopLoader(false));
      return;
    }

    // ---------- Query step2: review_request_id ベースでその他写真取得 ----------
    // ★ padtep を使うかどうかで JOIN ブロックを切り替え
    const padtepJoinBlockForSql2 = isSpecialMission
      ? `
        JOIN power_asset pa ON pa.id = ppa.power_asset_id
        LEFT OUTER JOIN power_asset_id_with_air_insulated_switch paiwais
          ON paiwais.power_asset_id = pa.id
      `
      : `
        JOIN ${joinTableAdjustment} padtep ON ppa.power_asset_id = padtep.power_asset_id
        JOIN power_asset pa ON pa.id = padtep.power_asset_id
        LEFT OUTER JOIN power_asset_id_with_air_insulated_switch paiwais
          ON paiwais.power_asset_id = padtep.power_asset_id
      `;

    let sqlQuery2 = {
      query: `
        SELECT
          *,
          DATE_FORMAT(
            CONVERT_TZ(rre.occurred_datetime, '+00:00', '+09:00'),
            '%Y-%m-%d %H:%i:%s'
          ) AS occurred_datetime_jst,
          paiwais.power_asset_id AS insulated_switch,
          pa.*
        FROM review_request_photo_bind rrpb
        JOIN photo_of_power_asset ppa ON rrpb.photo_of_power_asset_id = ppa.id
        JOIN game_space gs ON gs.id = ppa.game_space_id
        JOIN game_term gt ON gt.id = gs.game_term_id
        JOIN player_state ps ON ps.player_id = ppa.player_id
        JOIN review_request_event rre ON rrpb.review_request_id = rre.review_request_id
        ${padtepJoinBlockForSql2}
        WHERE rrpb.review_request_id = '${reviewRequestId}'
        AND rre.type = 'APPLIED';
      `,
    };

    if (reviewRequestId == undefined) {
      sqlQuery2.query = `
        WITH target AS (
          SELECT
            ppa.power_asset_id,
            ppa.player_id,
            ppa.game_space_id,
            pae.occurred_datetime
          FROM photo_of_power_asset ppa
          JOIN power_asset_event pae
            ON pae.power_asset_id = ppa.power_asset_id
          AND pae.player_id      = ppa.player_id
          AND pae.game_space_id  = ppa.game_space_id
          AND pae.type           = 'PHOTOGRAPH'
          WHERE ppa.file_name = '${safeFileName}'
          ORDER BY pae.occurred_datetime DESC
          LIMIT 1
        )
        SELECT
          ppa.*,
          gs.*,
          gt.*,
          ps.*,

          ${isSpecialMission ? "" : `
          padtep.prefectural_area,
          padtep.exchange_office_name,
          padtep.asset_info,
          padtep.photography_target,
          `}

          DATE_FORMAT(
            CONVERT_TZ(t.occurred_datetime, '+00:00', '+09:00'),
            '%Y-%m-%d %H:%i:%s'
          ) AS occurred_datetime_jst,

          paiwais.power_asset_id AS insulated_switch,

          pa.latitude,
          pa.longitude,
          pa.sub_type,
          pa.id AS pa_id

        FROM target t
        JOIN photo_of_power_asset ppa
          ON ppa.power_asset_id = t.power_asset_id
        AND ppa.player_id      = t.player_id
        AND ppa.game_space_id  = t.game_space_id

        JOIN power_asset_event pae
          ON pae.power_asset_id = ppa.power_asset_id
        AND pae.player_id      = ppa.player_id
        AND pae.game_space_id  = ppa.game_space_id
        AND pae.type           = 'PHOTOGRAPH'
        AND pae.occurred_datetime = t.occurred_datetime

        JOIN game_space gs ON gs.id = ppa.game_space_id
        JOIN game_term gt ON gt.id = gs.game_term_id
        JOIN player_state ps ON ps.player_id = ppa.player_id
        JOIN power_asset pa ON pa.id = ppa.power_asset_id

        LEFT JOIN power_asset_id_with_air_insulated_switch paiwais
          ON paiwais.power_asset_id = ppa.power_asset_id

        ${isSpecialMission ? "" : `LEFT JOIN ${joinTableAdjustment} padtep ON padtep.power_asset_id = ppa.power_asset_id`}

        ORDER BY ppa.file_name ASC;
      `;
    }

    const [imageFilesDataTemp] = yield all([
      call(getDataFromKpiDash, sqlQuery2, ENDPOINT.GET_DATA_API_REPLICA),
    ]);
    let imageFilesData = JSON.parse(imageFilesDataTemp.body);

    // Query step3: Get all signedUrls
    let photoPathArray = [],
      photoFileNameArray = [];
    _.each(imageFilesData, function (photoData) {
      photoPathArray.push(photoData.object_key);
      photoFileNameArray.push(photoData.file_name);
    });

    _.each(imageFilesData, function (photoData, index) {
      photoData.signedUrl = `${S3_BUCKET_BASE_URL}/${encodeURIComponent(
        photoPathArray[index]
      )}`;
    });

    if (!imageFilesData?.length) {
      yield put(setViewerImageData([]));
      yield put(setPageTopLoader(false));
      return;
    }

    // update 0 index data from review request dateTime to photo sent dateTime
    imageFilesData[0].occurred_datetime_jst = imageReviewData[0][
      "occurred_datetime_jst"
    ]
      .slice(0, 19)
      .replace("T", " ");
    imageFilesData = _.sortBy(imageFilesData, (photoData) => {
      const angleValue = Number(photoData.power_asset_photography_angle_of_view_id);
      return Number.isFinite(angleValue) ? angleValue : Number.POSITIVE_INFINITY;
    });

    yield put(setViewerImageData(imageFilesData));
    yield put(setPageTopLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export default function* watchMapSettings() {
  yield takeEvery(VIEWER.GET_IMAGE_DATA_BY_FILENAME, handleImageDataByFileName);
}
